import { useState } from "react";

import { FAQS, FOOTER_COLUMNS } from "../landingContent";

/** Single-open accordion; clicking the open item closes it. Item 0 starts open. */
export function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="l-soft border-b" style={{ borderColor: "var(--line)" }}>
      <div className="l-container l-faq gap-36 py-88">
        <div data-reveal>
          <p className="l-eyebrow">FAQ</p>
          <h2 className="l-h2" style={{ fontSize: "clamp(28px, 4vw, 40px)" }}>
            Frequently asked questions
          </h2>
          <p className="l-intro text-15" style={{ maxWidth: "40ch" }}>
            Anything else, the docs go deeper — or ask in the trader channel.
          </p>
        </div>

        <div data-reveal className="flex flex-col">
          {FAQS.map((item, index) => {
            const isOpen = open === index;

            return (
              <div key={item.q} className="border-b" style={{ borderColor: "var(--line)" }}>
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? -1 : index)}
                  className="usdx-faq-btn flex w-full cursor-pointer items-center gap-16 border-0 bg-transparent px-4 py-20 text-left"
                  style={{ color: "var(--ink)" }}
                >
                  <span
                    className="flex-1 text-16 font-semibold"
                    style={{ letterSpacing: "-0.012em", textWrap: "pretty" }}
                  >
                    {item.q}
                  </span>
                  <span
                    className="grid h-26 w-26 flex-none place-items-center rounded-full border text-15 leading-1"
                    style={{
                      borderColor: "var(--line-strong)",
                      color: "var(--ink-muted)",
                      transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                      transition: "transform .22s",
                    }}
                  >
                    +
                  </span>
                </button>
                <div
                  className="overflow-hidden"
                  style={{
                    maxHeight: isOpen ? 300 : 0,
                    opacity: isOpen ? 1 : 0,
                    transition: "max-height .3s ease, opacity .25s ease",
                  }}
                >
                  <p
                    className="text-[14.5px]"
                    style={{
                      margin: 0,
                      padding: "0 40px 22px 4px",
                      lineHeight: 1.65,
                      color: "var(--ink-muted)",
                      textWrap: "pretty",
                    }}
                  >
                    {item.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

const SOCIALS = [
  { name: "X", glyph: "𝕏" },
  { name: "Discord", glyph: "◈" },
  { name: "Telegram", glyph: "➤" },
  { name: "GitHub", glyph: "⌥" },
];

export function LandingFooter() {
  const [subscribed, setSubscribed] = useState(false);

  return (
    <footer className="relative overflow-hidden">
      <div
        className="pointer-events-none absolute left-1/2 h-[400px] w-[900px] -translate-x-1/2"
        style={{
          bottom: -200,
          background: "radial-gradient(ellipse at center, var(--glow-a), transparent 70%)",
        }}
      />

      <div className="l-container relative pb-40 pt-72">
        <div
          data-reveal
          className="l-news mb-56 gap-22 rounded-20 border p-32"
          style={{ borderColor: "var(--line-strong)", background: "var(--surface)" }}
        >
          <div className="min-w-0 flex-1">
            <h3
              className="text-24 font-bold"
              style={{ margin: 0, fontFamily: "var(--font-display)", letterSpacing: "-0.022em" }}
            >
              Execution notes, every Thursday
            </h3>
            <p
              className="mt-8 text-[14.5px]"
              style={{ margin: "8px 0 0", color: "var(--ink-muted)", maxWidth: "48ch", textWrap: "pretty" }}
            >
              Fill-quality data, market-maker depth reports and protocol changes. No price talk.
            </p>
          </div>

          <form
            className="flex flex-none flex-wrap gap-10"
            onSubmit={(e) => {
              e.preventDefault();
              /* Wire to the real list provider; this only reflects the click. */
              setSubscribed(true);
            }}
          >
            <input
              type="email"
              required
              placeholder="you@desk.com"
              aria-label="Email"
              className="h-46 flex-1 rounded-full border px-16 text-[14.5px] outline-none"
              style={{
                minWidth: 220,
                borderColor: "var(--line-strong)",
                background: "var(--surface-muted)",
                color: "var(--ink)",
              }}
            />
            <button type="submit" className="l-pill l-pill-primary h-46 flex-none px-26 text-[14.5px]">
              {subscribed ? "Subscribed ✓" : "Subscribe"}
            </button>
          </form>
        </div>

        <div className="l-foot gap-36 border-b pb-40" style={{ borderColor: "var(--line)" }}>
          <div className="flex flex-col gap-14" style={{ maxWidth: "34ch" }}>
            <div className="flex items-center gap-10">
              <span className="l-mark h-32 w-32 text-14">X</span>
              <span
                className="text-[19px] font-extrabold"
                style={{ fontFamily: "var(--font-display)", letterSpacing: "-0.02em" }}
              >
                USDX
              </span>
            </div>
            <p className="text-14" style={{ margin: 0, color: "var(--ink-muted)", textWrap: "pretty" }}>
              Powering the future of decentralized derivatives. Non-custodial, permissionless, verifiable on-chain.
            </p>
            {/* Glyph placeholders — swap for the real icon set. */}
            <div className="mt-4 flex gap-8">
              {SOCIALS.map((social) => (
                <span
                  key={social.name}
                  aria-label={social.name}
                  aria-disabled="true"
                  title="Coming soon"
                  className="l-icon-btn l-foot-disabled h-34 w-34 text-13 font-bold"
                >
                  {social.glyph}
                </span>
              ))}
            </div>
          </div>

          {FOOTER_COLUMNS.map((column) => (
            <div key={column.title} className="flex flex-col gap-11">
              <span className="l-micro">{column.title}</span>
              {column.links.map((link) => (
                <span
                  key={link}
                  aria-disabled="true"
                  title="Coming soon"
                  className="usdx-foot-link l-foot-disabled text-14"
                >
                  {link}
                </span>
              ))}
            </div>
          ))}
        </div>

        <div className="flex flex-wrap items-center justify-between gap-14 pt-24">
          <span className="text-13" style={{ color: "var(--ink-subtle)" }}>
            © 2026 USDX Labs. All rights reserved.
          </span>
          <span className="text-12" style={{ color: "var(--ink-subtle)", maxWidth: "64ch", textWrap: "pretty" }}>
            Perpetual futures involve substantial risk of loss. Not available to persons in restricted jurisdictions.
          </span>
        </div>
      </div>
    </footer>
  );
}
